<core-debug-ui-items>
  <core-debug-ui-field label="Leader App">
    @if (leader()) {
      <span style="color: #2df702;">Yes</span>
    } @else {
      <span style="color: #f12f2f;">No</span>
    }
  </core-debug-ui-field>
</core-debug-ui-items>

<core-debug-ui-items [label]="'Apps (' + members().length + ')'">
  @for (item of members(); track item.id) {
    <core-debug-ui-field [label]="item.name">
      @if (item.self) {
        <span style="color: #f2f702;">Self</span>
      }

      @if (item.leader) {
        <span style="color: #2df702; margin-left: 4px;">Leader</span>
      }

      <span style="margin-left: 12px;">{{ item.id }}</span>

      <span style="margin-left: 12px;">{{ item.app.name }}</span>
      <span style="margin-left: 12px; text-transform: uppercase">{{ item.app.environment }}</span>
    </core-debug-ui-field>
  }
</core-debug-ui-items>
